import React, { useMemo } from "react";
import { VehicleStatus } from "../../../../store/reducers/dashboard/vehicles/statuses/types";
import { Item } from "@elements/barsChart/BarsChart";
import BarsChartWithLegend from "@elements/barsChartWithLegend/BarsChartWithLegend";
import {
	RowWithAreaFormatter
} from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/rowFormatters/RowFormatters";
import BaseChartTooltip from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/BaseChartTooltip";

type VehiclesStatusesChartProps = {
	statuses: VehicleStatus[]
}

const VehiclesStatusesChart = (props: VehiclesStatusesChartProps) => {
	const { statuses } = props;

	const convertStatusToChartItem = (status: VehicleStatus): Item => {
		return {
			id: status.status + `-${status.color}`,
			color: status.color,
			value: status.count,
			name: status.status
		}
	}

	const elementsToRender = useMemo(() => {
		return statuses.map(convertStatusToChartItem)
	}, [statuses])

	const getTooltipText = (point: Item) => {
		return <BaseChartTooltip
			elements={[point].map(child => ({
				id: child.id,
				color: child.color,
				name: child.name,
				area: child.value,
				dimension: ''
			}))}
			cellsInRow={2}
			RowFormatter={RowWithAreaFormatter}
		/>
	}

	return (
		<BarsChartWithLegend items={elementsToRender}
							 compareFn={(a, b) => a.name.localeCompare(b.name)}
			   				 suppressTooltipStyles
							 tooltipProps={{ trigger: 'hover' }}
							 getTooltipText={getTooltipText}
							 legendProps={{
								 height: 230,
								 headersR: [<div>Статус</div>, <div style={{ textAlign: 'end' }}>Количество техники</div>]
							 }}
		/>
	)
}

export default VehiclesStatusesChart;